import { CURRENCY, SUBSCRIPTION_STATUS, UserRole } from "@/constant/constants";
import { formRegEx, formRegExReplacer } from "@/data/regex";
import axios from "axios";
import classNames from "classnames";
import moment from "moment";
import Papa from "papaparse";
import { toast } from "react-toastify";
const secretKey = "bookito-secretKeyTest";
export const apiHeader = (token, isFormData) => {
  const headers = {
    "ngrok-skip-browser-warning": "69420",
    "timezone-offset": moment().utcOffset(),
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return { headers };
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const CreateFormData = (data) => {
  const formData = new FormData();
  for (let key in data) {
    formData.append(key, data[key]);
  }
  return formData;
};

export const formatMessageDate = (date) => {
  const messageDate = moment(date);
  const now = moment();
  const yesterday = moment().subtract(1, "day"); // Separate "yesterday" variable

  if (messageDate.isSame(now, "minute")) {
    // If the date is exactly now, show the current time, e.g., 'HH:mm A'
    return now.format("HH:mm A");
  } else if (messageDate.isSame(now, "day")) {
    // If the date is today, use fromNow()
    return messageDate.fromNow();
  } else if (messageDate.isSame(now.subtract(1, "day"), "day")) {
    // If the date is yesterday, use fromNow()
    return messageDate.fromNow();
  } else {
    // Otherwise, show the date in a standard format, e.g., 'DD/MM/YYYY'
    return messageDate.format("DD/MM/YYYY");
  }
};

export const formatDate = (date, format = "MM/DD/YYYY") => {
  const formattedDate = moment(date);
  return formattedDate.format(format);
};

export const formatTime = (time) => {
  const formattedTime = moment(time);
  return formattedTime.format("hh:mm A");
};

export function stripAllHtmlTags(input) {
  return input?.replace(/<[^>]*>?/gm, "");
}

const options = {
  onDownloadProgress: (progressEvent) => {
    const { loaded, total } = progressEvent;
  },
};

export function downloadFileFromUrl(fileUrl, filename) {
  axios
    .get(fileUrl, {
      responseType: "blob",
      ...options,
    })
    .then(function (response) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], {
          type: response.headers["content-type"],
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    })
    .catch((e) => {});
}

export const scrollToTop = (topVal = 0) => {
  window.scrollTo({
    top: topVal,
    behavior: "smooth",
  });
};

export const formatNumber = (num) => {
  if (num % 1 === 0) {
    return `${CURRENCY}${num?.toLocaleString()}`;
  } else {
    return `${CURRENCY}${num?.toFixed(2)?.toLocaleString()}`;
  }
};

export async function convertImageFile(file) {
  if (typeof window !== "undefined") {
    const heic2any = require("heic2any");
    if (file?.type === "image/heic") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
        });
        return new File(
          [convertedBlob],
          file.name.replace(/\.heic$/i, ".jpg"),
          {
            type: "image/jpeg",
            lastModified: Date.now(),
          }
        );
      } catch (error) {
        console.error("Error converting HEIC to JPEG:", error);
        throw error;
      }
    } else if (file?.type === "image/webp") {
      try {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.src = URL.createObjectURL(file);
        await new Promise((resolve) => {
          img.onload = resolve;
        });
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        return new Promise((resolve) => {
          canvas.toBlob((blob) => {
            const convertedFile = new File(
              [blob],
              file.name.replace(/\.webp$/i, ".jpg"),
              {
                type: "image/jpeg",
                lastModified: Date.now(),
              }
            );
            resolve(convertedFile);
          }, "image/jpeg");
        });
      } catch (error) {
        console.error("Error converting WebP to JPEG:", error);
        throw error;
      }
    }
    return file;
  }
}
export const handleConvertImages = async (files) => {
  // return files;
  const temp = [];
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    if (typeof file === "string") {
      temp.push(file);
    } else {
      const image = await convertImageFile(file);
      temp.push(image);
    }
  }
  return temp;
};

export const validateUrl = (url) => {
  const urlRegex =
    /^(https?:\/\/)(www\.)?([\w-]+\.)+[a-z]{2,}(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/i;
  return urlRegex.test(url);
};

export const quillValidateHandler = (
  params,
  toastMessage = "Please fill the home cms field!"
) => {
  let flag = true;
  for (let key in params) {
    const parsedHTML = new DOMParser().parseFromString(
      params[key],
      "text/html"
    );
    const plainText = parsedHTML.body.textContent || "";
    if (plainText?.trim() === "") {
      toast.error(toastMessage);
      flag = false;
      break;
    }
  }
  return flag;
};

export const validateDate = (date) => {
  if (!date) return null; // Return null if date is falsy

  // Check if date is a moment object and has a $d property
  if (date?.$d) {
    return moment(date.$d).format(); // Format if $d exists
  } else {
    return moment(date).format(); // Assume date is a valid input for moment
  }
};
export const getYearRange = () => {
  const years = [
    ...Array.from({ length: 5 }).map((_, i) => ({
      label: `${moment().subtract(i, "year").format("YYYY")}`,
      value: `${moment().subtract(i, "year").format("YYYY")}`,
    })),
  ];
  return years;
};
export const cn = (...args) => classNames(...args);

export const camelCaseToLower = (str) => {
  return str.replace(formRegEx, formRegExReplacer).toLowerCase();
};

export const urlPattern =
  /^(https?:\/\/)(www\.)?([\w-]+\.)+[a-z]{2,}(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/i;

export const validateNestedParams = (
  params,
  parentKey = "",
  options = { disallowEmptyArray: true }
) => {
  const formatKey = (rawKey) => {
    return rawKey
      .replace(/\[(\d+)\]/g, (_, i) => ` ${parseInt(i) + 1}`) // [0] => 1
      .split(".")
      .map(
        (part) =>
          part.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) // capitalize
      )
      .join(" → ");
  };

  if (Array.isArray(params)) {
    if (options.disallowEmptyArray && params.length === 0) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (let i = 0; i < params.length; i++) {
      const key = `${parentKey}[${i}]`;
      if (!validateNestedParams(params[i], key, options)) return false;
    }
  } else if (typeof params === "object" && params !== null) {
    const keys = Object.keys(params);
    if (keys.length === 0 && parentKey) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }

    for (const key of keys) {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (!validateNestedParams(params[key], fullKey, options)) return false;
    }
  } else {
    if (params === "" || params === null || params === undefined) {
      toast.error(`${formatKey(parentKey)} cannot be empty`);
      return false;
    }
  }

  return true;
};

export const RenderToast = ({ type = "error", message = "" }) => {
  let toastId = "error-render-toast";

  if (!type || !message) return;

  toast[type](message, {
    id: toastId,
  });
};

export const getYearOptions = (previousYear = 1950) => {
  const yearOptions = Array.from(
    { length: new Date().getFullYear() - previousYear + 1 },
    (_, i) => previousYear + i
  );

  return yearOptions.map((year) => ({
    label: year,
    value: year,
  }));
};

export const getID = (id) => (id ? id.slice(id.length - 7, id.length) : "");

// Helper function to parse time strings like "HH:mm" into { hours, minutes }
const parseTime = (timeStr) => {
  if (!timeStr || !/^\d{2}:\d{2}$/.test(timeStr)) {
    return null;
  }
  const [hours, minutes] = timeStr.split(":").map(Number);
  if (isNaN(hours) || isNaN(minutes) || hours > 24 || minutes > 59) {
    return null;
  }
  // Handle "24:00" as a valid end time
  if (hours === 24 && minutes !== 0) {
    return null;
  }
  return { hours, minutes };
};

export const convertToMilitaryTime = (timeStr) => {
  if (!timeStr) return;
  const [time, modifier] = timeStr.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  if (modifier === "PM" && hours !== 12) {
    hours += 12;
  } else if (modifier === "AM" && hours === 12) {
    hours = 0;
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
};

export const handleMilitaryToStandardTime = (timeStr) => {
  if (!timeStr) return;
  const [hours, minutes] = timeStr.split(":").map(Number);
  const modifier = hours >= 12 ? "PM" : "AM";
  const standardHours = hours % 12 || 12;
  return `${String(standardHours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )} ${modifier}`;
};

const convertMinutes = (minutes) => {
  if (!Number.isFinite(minutes) || minutes < 0) {
    return "Invalid duration";
  }

  const duration = moment.duration(minutes, "minutes");

  if (minutes >= 1440) {
    // ≥ 1 day (1440 minutes)
    const days = Math.floor(duration.asDays());
    return `${days} day${days !== 1 ? "s" : ""}`;
  } else if (minutes >= 60) {
    // ≥ 1 hour
    const hours = Math.floor(duration.asHours());
    const remainingMinutes = minutes % 60;
    return `${hours} hour${hours !== 1 ? "s" : ""}${
      remainingMinutes > 0
        ? `, ${remainingMinutes} minute${remainingMinutes !== 1 ? "s" : ""}`
        : ""
    }`;
  } else {
    return `${minutes} minute${minutes !== 1 ? "s" : ""}`;
  }
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const generateCsv = (data, fields) => {
  const csv = Papa.unparse({
    fields: fields,
    data: data,
    quotes: true, // Wrap every field in quotes
    quoteChar: '"',
    escapeChar: '"',
    delimiter: ",",
    header: true,
    newline: "\r\n",
    skipEmptyLines: false, // Skip empty lines
    columns: null, // Specify columns if you want to export only specific ones
  });

  return csv;
};

export const downloadCsv = (data, fieldsObj, fieldsArr, csvName) => {
  const leadsData = data?.map((item) => {
    const obj = {};
    fieldsArr?.forEach((field) => {
      obj[field] = item[fieldsObj[field]];
    });
    return obj;
  });
  const csv = generateCsv(leadsData, fieldsArr);
  const blob = new Blob([csv], {
    type: "text/csv",
  });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${csvName}.csv`;
  link.click();
};
export const camelCaseToUpperCase = (string) => {
  const s = camelCaseToLower(string);
  // for first letter capitalize
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getUserName = (user) => {
  if (user?.firstName || user?.lastName) {
    return user?.firstName + " " + user?.lastName;
  } else if (user?.name) {
    return user?.name;
  } else {
    return "-";
  }
};
